import React, { useState } from 'react';
import AddAircraftModal from '../AddAircraftModal';

const ActionCards: React.FC = () => {
  const [showAddAircraft, setShowAddAircraft] = useState(false);

  return (
    <>
    <div className="row mb-4">
      <div className="col-md-4 mb-3">
        <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 style={{ fontWeight: 700, fontSize: '14px', color: '#687088' }}>Profilersteinrichtung</h5>
              <span
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  borderRadius: '50%',
                  width: '28px',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                1
              </span>
            </div>
            <button className="btn btn-primary w-100" style={{ fontWeight: 700, fontSize: '13px', color: 'white' }}>
              Jetzt bearbeiten
            </button>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-3">
        <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 style={{ fontWeight: 700, fontSize: '14px', color: '#687088' }}>Landungsmeldungen</h5>
              <span
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  borderRadius: '50%',
                  width: '28px',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                2
              </span>
            </div>
            <button className="btn btn-primary w-100" style={{ fontWeight: 700, fontSize: '13px', color: 'white' }}>
              Kritische Landungen ansehen
            </button>
          </div>
        </div>
      </div>
      <div className="col-md-4 mb-3">
        <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
          <div className="card-body p-4">
            <div className="mb-3">
              <h5 style={{ fontWeight: 700, fontSize: '14px', color: '#687088' }}>Neues Flugobjekt?</h5>
            </div>
            <button
              className="btn btn-primary w-100"
              style={{ fontWeight: 700, fontSize: '13px', color: 'white' }}
              onClick={() => setShowAddAircraft(true)}
            >
              Weiteres Luftfahrzeug hinzufügen
            </button>
          </div>
        </div>
      </div>
    </div>

    {showAddAircraft && (
      <AddAircraftModal
        onClose={() => setShowAddAircraft(false)}
      />
    )}
  </>
  );
};

export default ActionCards;
